export default __webpack_public_path__ + "static/PromptImageOneFullSize-48cf01fbcd7a5147927c3a2c988fd639.png";